module.exports = __webpack_public_path__ + "static/media/lock.f1a975a4.svg";